// 默认热门首页运输商
export const defaultHotCarriers = [
  21051, 100002, 100003, 100001, 100062, 100005, 100331, 1151, 100040, 100030, 100007, 100012, 190271, 100295, 3011,
  190008
]

// 默认www首页热门运输商,目前注释的是www写的默认运输商列表存在部分我们carriers没有的内容
// const defaultWwwHotCarriers = [
//   190271, 100296, 1000003, 190172, 190008, 190002, 190120, 190208, 190011, 190200, 100011, 190086, 190018, 190074,
//   190072, 190085, 190047, 190644, 190199, 190274
// ]

// 特殊国家与语言热门运输商
export const carriersCountryLangMap = {
  US: {
    en: [
      21051, 100002, 100003, 100001, 100062, 100005, 100331, 1151, 100040, 100030, 100007, 100012, 190271, 100295, 3011,
      190008
    ]
  }
}

// 预留定义特殊合作配置,这里的结构和carriers运输商结构一致,type用于标识是否是特殊自定义配置合作商
export const cooperationPartner = {
  cjDropshipping: {
    type: 'customPartner',
    isBlank: true,
    key: 999001,
    _name: 'CJ Dropshipping',
    '_name_zh-cn': 'CJ Dropshipping',
    '_name_zh-hk': 'CJ Dropshipping',
    _showUrl: 'https://www.cjdropshipping.com/?token=5599f19d-0b2d-439b-bc37-c4f6861add5c',
    _url: 'https://www.cjdropshipping.com/?token=5599f19d-0b2d-439b-bc37-c4f6861add5c',
    _detail: '',
    '_detail_zh-cn': '',
    '_detail_zh-hk': ''
  }
}
// 默认国家热门运输商
export const defaultWwwHotCarriers = [
  [21051, 100237, 100003],
  [3011, 190341, 100002, 100001],
  [190008, 11031, 190271, 9071, 190012, 6051]
]

/**
 * 首页运输商滚动列表
 */
export const carriersBannerList = [
  21051, 100002, 100003, 100308, 3011, 190094, 100685, 100264, 190008, 11031, 190012, 190625, 100036, 9021, 190199,
  100134, 190284, 1151, 100315, 190168, 190200, 190120, 100425, 190844, 21021, 100018, 190899, 100475, 190086, 18031,
  7044, 16081
]

// 特殊国家热门运输商
export const carriersCountryMap = {
  cn: [
    [190008, 190002, 191360], // 第一组
    [190208, 190172, 190200, 190199], // 第二组
    [190086, 190194, 3011, 100001, 1000005] // 第三组
  ],
  us: [
    [21051, 100003, 100002], // 第一组
    [999001, 100001, 100308, 100049], // 第二组
    [3011, 100783, 100254, 100221, 100242, 190094] // 第三组
  ], // 美国
  de: [
    [100001, 100007, 100005], // 第一组
    [100018, 100002, 100003, 100308], // 第二组
    [21051, 100004, 11031, 3011, 190008, 190012] // 第三组
  ], // 德国
  it: [
    [100005, 9071, 100001], // 第一组
    [100004, 100002, 100003, 100458], // 第二组
    [21051, 11031, 190625, 3011, 190008, 190012] // 第三组
  ], // 意大利
  fr: [
    [100001, 100002, 100003], // 第一组
    [21051, 6051, 100005, 11031], // 第二组
    [100004, 100273, 100685, 9021, 190094, 3011] // 第三组
  ], // 法国
  es: [
    [19181, 100001, 190625], // 第一组
    [100002, 100005, 100438, 11031], // 第二组
    [190438, 21051, 100175, 100685, 3011, 100003] // 第三组
  ], // 西班牙
  pt: [
    [100001, 16101, 100002], // 第一组
    [100005, 100003, 100004, 11031], // 第二组
    [190625, 21051, 9021, 6051, 100069, 100767] // 第三组
  ], // 葡萄牙
  ru: [
    [100157, 100001, 9021], // 第一组
    [100003, 21051, 100002, 190625], // 第二组
    [11031, 100069, 100012, 100685, 3011, 100005] // 第三组
  ], // 俄罗斯
  tr: [
    [20111, 100607, 100348], // 第一组
    [100608, 100703, 100642, 100002], // 第二组
    [100925, 190625, 100001, 100297, 100044, 100003] // 第三组
  ], // 土耳其
  id: [
    [100086, 9031, 100588], // 第一组
    [100590, 100074, 100597, 100586], // 第二组
    [100589, 100904, 100409, 100183, 100511, 100344] // 第三组
  ],
  default: [
    [21051, 100237, 100003],
    [3011, 190341, 100002, 100001],
    [190008, 11031, 190271, 9071, 190012, 6051]
  ]
}

// platform 详情底部banner轮播
export const platformCarriersBanner = [
  21051, 100003, 100002, 100001, 100308, 100049, 3011, 100783, 100254, 100221, 100242, 190094, 190012
]

/**
 * tracking page & carrier detail 底部推荐运输商模块
 * 数字代表运输商id，对象代表brands
 */
const recommendCarriers = {
  us: [
    21051,
    100002,
    100003,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    3011,
    190094,
    100685,
    100264,
    190008,
    11031,
    190012,
    190625,
    100036,
    9021,
    190199,
    100134,
    {
      _name: 'Dhgate',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241128/9395c6b4af9f47119b2694c36ae99c05'
    },
    {
      _name: 'Ebay',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241128/8a0df49c84804979b24b02d7e31a44ad'
    },
    {
      _name: 'Shein',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20250123/918c2df38207459197fc0b825622c258'
    },
    190284
  ],
  uk: [
    11031,
    100010,
    100017,
    11033,
    100002,
    100018,
    100003,
    21051,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    3011,
    3013,
    190094,
    190008,
    {
      _name: 'Dhgate',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241128/9395c6b4af9f47119b2694c36ae99c05'
    },
    190012,
    190625,
    190208,
    190200,
    6051,
    {
      _name: 'Shein',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20250123/918c2df38207459197fc0b825622c258'
    }
  ],
  ca: [
    3041,
    100002,
    100003,
    100999,
    100001,
    21051,
    100555,
    9021,
    3011,
    100029,
    3013,
    190012,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    100036,
    100264,
    100527,
    190625,
    190094,
    100134,
    100552
  ],
  de: [
    100007,
    100031,
    100005,
    100002,
    7044,
    100003,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    100001,
    21051,
    101079,
    11031,
    3011,
    190012,
    190625,
    190094,
    14041,
    100685,
    100164,
    190012,
    190200
  ],
  it: [
    100024,
    9071,
    100019,
    100469,
    190625,
    11031,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    190008,
    3011,
    7044,
    {
      _name: 'Shein',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20250123/918c2df38207459197fc0b825622c258'
    },
    3013,
    100304,
    190012,
    100031,
    100012,
    190113,
    100475,
    // {
    //   _name: 'Amazon',
    //   type: 'brands',
    //   icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    // },
    100026,
    14044
  ],
  es: [
    19181,
    100005,
    100438,
    100175,
    100114,
    100219,
    190625,
    100364,
    100007,
    100435,
    101048,
    190271,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    3011,
    100685,
    190008,
    100031,
    100597,
    11031,
    190113
  ],
  fr: [
    100005,
    100002,
    101079,
    100007,
    21051,
    100004,
    11031,
    {
      _name: 'Shein',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20250123/918c2df38207459197fc0b825622c258'
    },
    190271,
    {
      _name: 'Amazon',
      type: 'brands',
      icon: 'https://static-asset.17track.net/web/platform/20241115/720d0f42a40b4f8fa62f439c62655e84'
    },
    100304,
    3011,
    100685,
    190625,
    190008,
    7044,
    6051,
    100273,
    14041,
    100031
  ]
}

/**
 * 获取当前国家的推荐运输商
 * 语种为en时，根据国家获取，否则根据语种获取，否则默认us
 * @param {*} country
 * @param {*} locale
 * @returns
 */
export const getCurrentRecommendCarriers = (country, locale) => {
  let list = null
  if (locale === 'en') {
    list = recommendCarriers?.[country?.toLowerCase()]
  }
  return list || recommendCarriers?.[locale] || recommendCarriers.us
}

// 定义seo carriers 运输商不同的seo文章映射关系
export const carriersSeo = {
  seo: [
    100001, 100002, 100003, 100004, 100005, 100007, 100049, 100012, 100052, 100221, 100242, 100254, 100308, 100331,
    100340, 100398, 100441, 100685, 100782, 100783, 11031, 1151, 190008, 190012, 190094, 190199, 190271, 190625, 21051,
    3011, 3041
  ],
  normal: [
    100011, 100015, 100016, 100028, 100061, 100121, 100143, 100149, 100166, 100217, 100232, 100263, 100269, 100272,
    100302, 100305, 100328, 100332, 100333, 100343, 100362, 100395, 100427, 100429, 100439, 100440, 100442, 100443,
    100445, 100447, 100448, 100453, 100454, 100473, 100502, 100522, 100545, 100557, 100613, 100614, 100645, 100678,
    100679, 100684, 100690, 100695, 100733, 100736, 100742, 100743, 100751, 100752, 100758, 100784, 100805, 100817,
    100818, 100819, 100831, 100839, 100852, 100885, 100899, 100913, 100914, 100916, 100922, 100929, 100957, 100960,
    100964, 100971, 100972, 100982, 100992, 100995, 101017, 101023, 101024, 101025, 101027, 101028, 101036, 101037,
    191206, 191299
  ]
}

/**
 * page 多语言映射
 */
const PAGE_LOCAL_MAP = {
  en: 'Page',
  az: 'Səhifə',
  bg: 'Страница',
  cs: 'Stránka',
  da: 'Side',
  de: 'Seite',
  el: 'Σελίδα',
  es: 'Página',
  fi: 'Sivu',
  fr: 'Page',
  hu: 'Oldal',
  it: 'Pagina',
  ja: 'ページ',
  kk: 'Бет',
  ko: '페이지',
  lt: 'Puslapis',
  mk: 'Страница',
  nl: 'Pagina',
  no: 'Side',
  pl: 'Strona',
  pt: 'Página',
  ro: 'Pagina',
  ru: 'Страница',
  sk: 'Stránka',
  sl: 'Stran',
  sq: 'Faqe',
  sr: 'Страница',
  sv: 'Sida',
  th: 'หน้า',
  tr: 'Sayfa',
  uk: 'Сторінка',
  'zh-cn': '页面',
  'zh-hk': '頁面'
}

const carriersConfig = {
  carriersCountryMap, // 特殊热门国家运输商
  defaultWwwHotCarriers, // 特殊www首页热门国家运输商
  carriersCountryLangMap, // 特殊热门国家与语言运输商
  defaultHotCarriers, // 默认热门运输商
  cooperationPartner, // 特殊合作品牌配置
  carriersSeo, // 定义seo carriers 运输商不同的seo文章映射关系
  PAGE_LOCAL_MAP,
  platformCarriersBanner
}

export default carriersConfig
